import { useEffect, useState } from 'react';

interface Props {
  base: string;
  hcd: boolean;
  navegar: (url: string) => void;
}

/**
 * Barra de navegación con la misma lógica que www.lujan.gob.ar: transparente sobre la portada
 * y con fondo azul translúcido al desplazarse.
 */
export function Encabezado({ base, hcd, navegar }: Props) {
  const [desplazado, setDesplazado] = useState(false);
  const [menuAbierto, setMenuAbierto] = useState(false);

  useEffect(() => {
    const alDesplazar = () => setDesplazado(window.scrollY > 40);
    alDesplazar();
    window.addEventListener('scroll', alDesplazar, { passive: true });
    return () => window.removeEventListener('scroll', alDesplazar);
  }, []);

  const ir = (url: string) => (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    setMenuAbierto(false);
    navegar(url);
  };
  const sitio = hcd
    ? { url: 'https://hcd.lujan.gob.ar/', texto: 'Ir al sitio del HCD' }
    : { url: 'https://www.lujan.gob.ar/', texto: 'Ir a lujan.gob.ar' };

  return (
    <nav
      className={`barra ${desplazado || menuAbierto ? 'barra--solida' : ''}`}
      aria-label="Navegación principal"
    >
      <div className="contenedor barra__interior">
        <a className="barra__logo" href="https://www.lujan.gob.ar/">
          <img src="/img/logo-lujan.png" alt="Municipalidad de Luján" width={121} height={38} />
        </a>
        <button
          type="button"
          className="barra__menu"
          aria-expanded={menuAbierto}
          aria-controls="menu-principal"
          aria-label={menuAbierto ? 'Cerrar menú' : 'Abrir menú'}
          onClick={() => setMenuAbierto((a) => !a)}
        >
          <span aria-hidden="true" />
        </button>
        <ul id="menu-principal" className={`barra__enlaces ${menuAbierto ? 'barra__enlaces--abierto' : ''}`}>
          <li>
            <a href={base} onClick={ir(base)} aria-current="page">
              Buscar normas
            </a>
          </li>
          <li>
            <a className="barra__sitio" href={sitio.url}>
              {sitio.texto}
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export function Portada({ titulo, bajada }: { titulo: string; bajada: string }) {
  return (
    <header className="portada">
      <div className="contenedor portada__interior">
        <h1>{titulo}</h1>
        <p>{bajada}</p>
      </div>
    </header>
  );
}
